import React from 'react'

/// PAGAR — menangkap galat render supaya layar tidak jadi putih polos.
///
/// ── KENAPA INI ADA ──────────────────────────────────────────────────────────
///
/// React MEMBONGKAR seluruh pohon komponen kalau ada satu galat saat render dan
/// tidak ada yang menangkapnya. Yang tersisa di layar: putih. Tidak ada pesan,
/// tidak ada tombol, tidak ada petunjuk halaman mana yang bermasalah.
///
/// 25 Agu 2026: "karaoke ketika klik siapkan di master lagu blank page". Dari
/// gejala itu tidak ada satu pun yang bisa disimpulkan — bisa galat data, bisa
/// bundle lama, bisa apa saja. Waktunya habis untuk menebak, padahal galatnya
/// sudah ada di tangan peramban sejak detik pertama.
///
/// Pagar ini tidak memperbaiki galatnya. Ia cuma memastikan galat berikutnya
/// TERBACA — dan itu bedanya antara satu putaran perbaikan dan lima.
///
/// ── KENAPA PESAN ASLINYA DITAMPILKAN ────────────────────────────────────────
///
/// Bukan "terjadi kesalahan, hubungi admin". Yang memakai layar admin karaoke
/// adalah orang yang bisa menyalin pesan itu ke WhatsApp, dan pesan asli
/// menghemat satu putaran penuh tanya-jawab. Aplikasi ini juga tidak dibuka
/// tamu — tidak ada rahasia yang bocor ke orang luar lewat sini.
///
/// Layar TAMU (/r/) dan TV (/p/) memakai pagar yang sama tapi pesannya
/// disembunyikan: di sana yang membaca memang bukan orang yang bisa berbuat
/// apa-apa dengan stack trace.
type Props = { children: React.ReactNode; tampilkanRincian?: boolean }
type State = { galat: Error | null }

export default class Pagar extends React.Component<Props, State> {
  state: State = { galat: null }

  static getDerivedStateFromError(galat: Error): State {
    return { galat }
  }

  componentDidCatch(galat: Error, info: React.ErrorInfo) {
    // Ikut ke Console supaya tetap ada jejak lengkapnya walau layarnya sudah
    // diganti pesan ramah.
    console.error('[karaoke] galat render:', galat, info.componentStack)
  }

  render() {
    const { galat } = this.state
    if (!galat) return this.props.children

    const rinci = this.props.tampilkanRincian ?? true

    return (
      <div className="min-h-screen bg-bg-0 text-text-1 flex items-center justify-center p-6">
        <div className="max-w-lg w-full rounded-2xl border border-red-500/30 bg-red-500/[0.06] p-5">
          <h1 className="text-[15px] font-semibold text-red-300">
            Halaman ini berhenti bekerja
          </h1>
          <p className="text-[12.5px] text-text-3 mt-1.5 leading-relaxed">
            Bagian lain aplikasi masih jalan. Muat ulang halaman untuk kembali;
            kalau berulang, salin pesan di bawah dan kirim ke yang mengerjakan.
          </p>

          {rinci && (
            <pre className="mt-3 text-[11px] leading-relaxed whitespace-pre-wrap
                            break-words bg-black/30 rounded-lg p-3 max-h-56 overflow-auto">
              {galat.message}
              {galat.stack ? `\n\n${galat.stack.split('\n').slice(1, 6).join('\n')}` : ''}
            </pre>
          )}

          <div className="flex gap-2 mt-4">
            <button
              onClick={() => location.reload()}
              className="px-3 py-1.5 rounded-lg text-[12.5px] bg-gold/15 text-gold border border-gold/30">
              Muat ulang
            </button>
            {rinci && (
              <button
                onClick={() => navigator.clipboard?.writeText(
                  `${galat.message}\n\n${galat.stack ?? ''}`)}
                className="px-3 py-1.5 rounded-lg text-[12.5px] border border-border text-text-3">
                Salin pesan
              </button>
            )}
          </div>
        </div>
      </div>
    )
  }
}
